<template>
  <div class="middleBlock">
    <div class="numberTotal">
      <div class="probability">
        <div class="row" v-for="item in preList" :key="item.name"  @click="detailClick(item)">
          <div style="width: 100%">
            <span class="colorOne">{{ item.label }}</span>
            <img src="../../../../../static/img/21.png" alt="" class="arrowMore" />
          </div>
          <div style="width: 100%">
            <span>同比+{{ item.per }}</span>
            <img class="arrow" src="../../../../../static/img/13.png" alt="" />
          </div>
        </div>
      </div>
      <div class="img">
        <div v-for="(one, index) in oneNumber" :key="'one' + index">
          <div class="block block1" :class="[index === 4 ? 'noneMargin' : '']" :style="{ fontSize: blockFontSize + 'px' }">
            {{ one }}
          </div>
        </div>
        <div class="line"></div>
        <div v-for="(two, index) in twoNumber" :key="'two' + index">
          <div class="block block2" :class="[index === 4 ? 'noneMargin' : '']" :style="{ fontSize: blockFontSize + 'px' }">
            {{ two }}
          </div>
        </div>
        <div class="line"></div>
        <div v-for="(three, index) in threeNumber" :key="'three' + index">
          <div class="block block3" :class="[index === 4 ? 'noneMargin' : '']" :style="{ fontSize: blockFontSize + 'px' }">
            {{ three }}
          </div>
        </div>
      </div>
    </div>
    <div class="barChart">
      <div class="title">
        <img src="../../../../../static/img/28.png" alt="" />
        <div>近十年专利公开量</div>
        <img src="../../../../../static/img/21.png" alt="" />
      </div>
      <div class="barEchart">
        <Bar :options="options" @echartClick="echartClick"></Bar>
      </div>
    </div>
  </div>
</template>
<script>
import Bar from '@/components/echarts/Bar'
import { perIncrease, yearRange } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'

export default {
  mixins: [BaseMixin],
  data() {
    return {
      preList: [
        {
          label: '专利申请',
          count: 0,
          per: '',
          name: 'apply',
          countList: 'oneNumber',
          exp: '专利类型=(发明申请 or 实用新型 or 外观设计)'
        },
        {
          label: '专利授权',
          count: 0,
          per: '',
          name: 'authorization',
          countList: 'twoNumber',
          exp: '专利类型=(发明授权 or 实用新型 or 外观设计)'
        },
        {
          label: '专利有效',
          count: 0,
          per: '',
          name: 'effect',
          countList: 'threeNumber',
          exp: '专利类型=(发明授权 or 实用新型 or 外观设计) and 专利状态=(有效)'
        }
      ],
      oneNumber: ['0', '0', '0', '0', '0'],
      twoNumber: ['0', '0', '0', '0', '0'],
      threeNumber: ['0', '0', '0', '0', '0'],
      options: {},
      typeList: [
        { name: 'invent', label: '发明专利/件', data: [], value: '发明申请' },
        { name: 'newKind', label: '实用新型/件', data: [], value: '实用新型'},
        { name: 'exterior', label: '外观设计/件', data: [], value: '外观设计' }
      ],
      xData: []
    }
  },
  components: {
    Bar
  },
  computed: {
    // 计算block的动态字体大小
    blockFontSize() {
      const total = this.oneNumber.length + this.twoNumber.length + this.threeNumber.length
      if (this.imgWidth === 0 || total === 0) return 60
      const remainWidth = this.imgWidth - total * 8 - 68 // 减去每个 block 的右 margin
      return Math.floor(remainWidth / total)
    }
  },
  mounted() {
    this.getTotal()
    this.getYearRange()
    this.barEcharts()
    this.$nextTick(() => {
      this.calculateImgWidth()
    })
  },
  methods: {
    // 计算图片宽度
    calculateImgWidth() {
      const imgElement = this.$el.querySelector('.img')
      if (imgElement) {
        this.imgWidth = imgElement.offsetWidth
      }
    },
    echartClick(params) {
      let exp = params.data.label
      if (params.data.label === '发明申请') {
        exp = '发明申请 or 发明授权'
      }
      this.jumpIpi(`专利类型=(${exp}) and 公开年=${params.name}`, 'isMerge')
    },
    detailClick(item) {
      this.jumpIpi(item.exp)
    },
    getTotal() {
      perIncrease().then((res) => {
        if (res[this.codeMapping]) {
          this.preList.forEach((item) => {
            res[this.dataMapping].forEach((ele) => {
              if (item.name === ele.name) {
                item.count = ele.count
                item.per = ele.per
              }
            })
          })
          this.addZero()
          //  分解count
          this.preList.forEach((item) => {
            const arr = String(item.count).split('')
            this[item.countList] = arr
          })
        }
      })
    },
    addZero() {
      // 判断每个数量不足4位数,前面添加0
      this.preList.forEach((item) => {
        const str = String(item.count)
        if (str.length < 5) {
          item.count = '0' + str
          this.addZero()
        }
      })
    },
    getYearRange() {
      yearRange().then((res) => {
        //
        if (res[this.codeMapping]) {
          res[this.dataMapping].forEach((item) => {
            this.typeList.forEach((ele) => {
              if (item.name === ele.name) {
                item.name = ele.label
              }
            })
            if (this.xData.every(items => items !== item.year)) {
              this.xData.push(item.year)
            }
          })
          res[this.dataMapping].forEach((item) => {
            this.typeList.forEach((ele) => {
              if (item.name === ele.label) {
                ele.data.push({value: item.count, label: ele.value})
              }
            })
          })
          this.barEcharts()
        }
      })
    },
    barEcharts() {
      const color = ['#009DF3', '#00FFFF', '#6633FF', '#e5323e']
      this.options = {
        legend: {
          show: true,
          icon: 'roundRect',
          textStyle: {
            color: '#fff',
            fontSize: 16
          },
          itemGap: 35
        },
        grid: {
          left: '15%',
          top: '15%',
          bottom: '20%'
        },
        tooltip: {
          show: true,
          textStyle: {
            fontSize: 17 // 设置字体大小
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#97A8C2'
            }
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#F0F0F0'
            }
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          name: '',
          nameTextStyle: {
            color: '#A6D3FD',
            fontSize: 14,
            align: 'left'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#97A8C2'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#F0F0F0'
            }
          }
        },
        series: []
      }
      this.options.legend.data = []

      this.typeList.forEach((item, index) => {
        const obj = {
          type: 'bar',
          itemStyle: {
            normal: {
              borderRadius: [40, 40, 0, 0],
              color: ''
            }
          },
          barWidth: 8,
          barGap: '90%',
          name: '',
          data: []
        }
        obj.name = item.label
        obj.data = item.data
        obj.itemStyle.normal.color = color[index]
        this.options.series.push(obj)
        this.options.legend.data.push({ icon: 'roundRect', name: item.label })
      })
    }
  }
}
</script>
